import { useImpersonate } from '@/contexts/ImpersonateContext';
import { Shield, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export default function ImpersonateBanner() {
  const { isImpersonating, impersonatedName, impersonatedCompany, stopImpersonate } =
    useImpersonate();
  const navigate = useNavigate();

  if (!isImpersonating) return null;

  return (
    <div className="sticky top-0 z-[100] flex items-center justify-between bg-amber-500 px-4 py-2 text-sm font-medium text-amber-950">
      <div className="flex items-center gap-2">
        <Shield className="h-4 w-4" />
        <span>
          Session Admin — Vous gérez le compte de <strong>{impersonatedName}</strong>
          {impersonatedCompany && (
            <>
              {' '}
              pour la société <strong>{impersonatedCompany}</strong>
            </>
          )}
        </span>
      </div>
      <Button
        size="sm"
        variant="outline"
        className="h-7 border-amber-700 bg-amber-600 text-xs text-white hover:bg-amber-700"
        onClick={() => {
          stopImpersonate();
          navigate('/admin-portal');
        }}
      >
        <ArrowLeft className="mr-1 h-3 w-3" />
        Retour Admin
      </Button>
    </div>
  );
}
